import { CantileverButton } from 'components/CantileverButton'
import { useScatterplotContext } from 'features/timeSeries'
import {
  ModeToggleContainer,
  SectionLabel,
  ToggleAndLabelContainer,
} from 'features/timeSeries/sharedStyles'
import React from 'react'
import styled from 'styled-components'

const ToggleButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`

export const YAxisModeSection: React.FC = () => {
  const {
    singleScaleMode,
    autoScaleMode,
    handleAutoScaleModeToggle,
    handleScaleModeToggle,
  } = useScatterplotContext()

  return (
    <ToggleAndLabelContainer>
      <SectionLabel>Y Axis Mode</SectionLabel>
      <ToggleButtonsContainer>
        <ModeToggleContainer>
          <CantileverButton
            ghost={autoScaleMode}
            onClick={() => handleAutoScaleModeToggle(false)}>
            Custom Scale
          </CantileverButton>
          <CantileverButton
            ghost={!autoScaleMode}
            onClick={() => handleAutoScaleModeToggle(true)}>
            Auto Scale
          </CantileverButton>
        </ModeToggleContainer>
        <ModeToggleContainer>
          <CantileverButton
            ghost={!singleScaleMode}
            onClick={() => handleScaleModeToggle(true)}>
            Single Scale
          </CantileverButton>
          <CantileverButton
            ghost={singleScaleMode}
            onClick={() => handleScaleModeToggle(false)}>
            Multiple Scales
          </CantileverButton>
        </ModeToggleContainer>
      </ToggleButtonsContainer>
    </ToggleAndLabelContainer>
  )
}
